import { SkeletonBox, SkeletonButton, SkeletonText } from '@billy/design-system'

import * as Styled from './styles'

export const AttachmentTileSkeleton = () => {
  return (
    <Styled.AttachmentTileSkeletonWrapper>
      <Styled.SkeletonImageWrapper>
        <SkeletonBox fullWidth fullHeight />
      </Styled.SkeletonImageWrapper>
      <Styled.SkeletonContentWrapper>
        <SkeletonText variant="bodySM" />
        <Styled.SkeletonFooter>
          <SkeletonButton fullWidth size="md" />
        </Styled.SkeletonFooter>
      </Styled.SkeletonContentWrapper>
    </Styled.AttachmentTileSkeletonWrapper>
  )
}
